module.exports = __webpack_public_path__ + "img/step-icon-schedule.e95cbb90.svg";